export const BASE = {
  name: 'survey-goals',
  path: '/sites/:siteId/survey-goals',
};
